import React, { useState } from 'react';
import styles from './DrawerPage.module.css';
import { Switch } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';
import Systems from '../SystemsOverview/SystemsOverview';
import SystemDetails from '../SystemDetails/SystemDetails';
import AddBESS from '../AddBESS/AddBESS';
import UpsertModule from '../UpsertModule/UpsertModule';
import ModuleLibrary from '../ModuleLibrary/ModuleLibrary';
import Analytics from '../Analytics/Analytics';
import Sidebar from './Sidebar';
import { useSize } from '../../hooks/useSize';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Logo from '../../assets/Logo/RePack_logo_text_transparent.png';

export default function DrawerPage() {
  const onSmallScreen = useSize();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return (
    <div className={styles.container}>
      <Sidebar
        variant={onSmallScreen ? 'temporary' : 'permanent'}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <main>
        {onSmallScreen && (
          <div className={styles.topPar}>
            <IconButton
              className={styles.showSidebarButton}
              onClick={() => setSidebarOpen(true)}
            >
              <MenuIcon fontSize={'large'} />
            </IconButton>
            <img src={Logo} alt={'RePack logo'} />
          </div>
        )}
        <div className={styles.content}>
          <Switch>
            <Route exact path="/systems">
              <Systems />
            </Route>
            <Route exact path="/system_details/:systemId">
              <SystemDetails />
            </Route>
            <Route exact path="/addsystem">
              <AddBESS />
            </Route>
            <Route exact path="/addmodule">
              <UpsertModule />
            </Route>
            <Route exact path={'/editmodule'}>
              <UpsertModule isNew={false} />
            </Route>
            <Route exact path="/modulelibrary">
              <ModuleLibrary />
            </Route>
            <Route exact path="/analytics">
              <Analytics />
            </Route>
            <Redirect to="/login" />
          </Switch>
        </div>
      </main>
    </div>
  );
}
